<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="600px">
      <v-card>
        <v-form
          ref="form"
          v-model="valid"
          method="post"
          enctype="multipart/form-data"
          lazy-validation
        >
          <v-card-title>
            <span class="headl">NUEVO PRODUCTO</span>
            <!-- <span>userID: {{ userId }}</span> -->
          </v-card-title>
          <v-tabs v-model="tab" background-color="primary" dark>
            <v-tab :key="1">GENERAL</v-tab>
            <v-tab :key="2">DESCRIPCIÓN</v-tab>
            <v-tab :key="3">INVENTARIO</v-tab>
            <v-tab :key="4">SOCIAL</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item :key="1">
              <v-card class="tab_tall" flat>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <p class="subhead">INFORMACIÓN BASICA</p>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          ref="name_product"
                          v-model="name_product"
                          :rules="nameRules"
                          label="Nombre del producto"
                          required
                        ></v-text-field>
                        <v-select
                          ref="shop"
                          v-model="shop"
                          item-value="_id"
                          item-text="name_shop"
                          :items="itemsShops"
                          :rules="[(v) => !!v || 'La tienda es requerida']"
                          label="Tiendas"
                          required
                        ></v-select>
                        <v-select
                          ref="category"
                          v-model="category"
                          item-value="name"
                          item-text="name"
                          :items="getCategoryOnly"
                          :rules="[(v) => !!v || 'La categoria es requerida']"
                          label="Categoria"
                          required
                        ></v-select>

                        <v-text-field
                          ref="brand"
                          v-model="brand"
                          :rules="inputRules"
                          label="Marca"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <div v-if="imgProduct" class="preview_img">
                          <img :src="preview" />
                        </div>
                        <v-file-input
                          accept="image/*"
                          v-model="imgProduct"
                          @change="onFileChange"
                          ref="imgProduct"
                          name="imgProduct"
                          label="Imagen principal"
                        ></v-file-input>
                        <v-select
                          ref="state"
                          v-model="state"
                          item-value="id"
                          item-text="name"
                          :items="itemsActive"
                          label="Estado"
                          required
                        ></v-select>
                        <v-text-field
                          ref="size"
                          v-model="size"
                          :rules="inputRules"
                          label="Tamaño"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :key="2">
              <v-card class="tab_tall" flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <p class="subhead">DESCRIPCIÓN</p>
                    </v-col>
                    <v-col cols="12">
                      <tiptap-vuetify
                        ref="description"
                        v-model="description"
                        :extensions="extensions"
                        required
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :key="3">
              <v-card class="tab_tall" flat>
                <v-card-text>
                  <p class="subhead">Agregar inventario</p>
                  <v-row>
                    <v-col cols="5">
                      <v-text-field
                        ref="priceInit"
                        v-model="priceInit"
                        label="Precio de referencia"
                        :rules="priceRules"
                        type="number"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="7">
                      <v-select
                        ref="discount"
                        v-model="discount"
                        :items="itemsDiscount"
                        label="¿Esta en descuento?"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="5">
                      <div class="divbox_add">
                        <v-row>
                          <v-col cols="6">
                            <v-text-field
                              ref="talla"
                              v-model="talla"
                              label="Talla"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              ref="color"
                              class="color_input"
                              v-model="color"
                              type="color"
                              :value="color"
                              label="Color"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              ref="price"
                              type="number"
                              v-model="price"
                              :rules="priceRules"
                              label="Precio"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              ref="cant"
                              type="number"
                              v-model="cant"
                              :rules="priceRules"
                              label="Cantidad"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <div class="cent-add">
                              <v-btn @click="addStock" large>Agregar</v-btn>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                    <v-col cols="7">
                      <p>Lista</p>
                      <div
                        class="cl_stock"
                        v-for="item in stock"
                        :key="item.id"
                      >
                        <div class="cl_item">
                          <span>
                            Talla:
                            <b>{{ item.talla }}</b>
                          </span>
                        </div>
                        <div class="cl_item">
                          <span>
                            Color: {{ item.color }}
                            <i
                              class="color_span"
                              :style="{ background: item.color }"
                            ></i>
                          </span>
                        </div>
                        <div class="cl_item">
                          <span>Precio: {{ item.price | currency }}</span>
                        </div>
                        <div class="cl_item">
                          <span>Cantidad: {{ item.cant }}</span>
                        </div>

                        <v-btn class="cl_close" icon @click="delStock(item)">
                          <span class="material-icons">close</span>
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :key="4">
              <v-card class="tab_tall" flat>
                <v-card-text>
                  <p class="subhead">Agregar codigo social</p>
                  <v-row>
                    <v-col cols="5">
                      <div class="divbox_add">
                        <v-row>
                          <v-col cols="12">
                            <v-textarea
                              outlined
                              ref="iframe"
                              v-model="iframe"
                              name="iframe"
                              label="Insertar código"
                            ></v-textarea>
                            <v-select
                              ref="redSocial"
                              item-value="name"
                              item-text="name"
                              v-model="redSocial"
                              :items="itemSocial"
                              label="Red social"
                            ></v-select>
                          </v-col>
                          <v-col cols="12">
                            <div class="cent-add">
                              <v-btn @click="addCodeSocial" large
                                >Agregar</v-btn
                              >
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                    <v-col cols="7">
                      <p>Lista</p>
                      <div class="list-data">
                        <div
                          class="cl_stock"
                          v-for="item in embeSocial"
                          :key="item.id"
                        >
                          <div class="cl_social">
                            <p>
                              <span>Red Social: </span>
                              <b>{{ item.redSocial }}</b>
                            </p>
                            <code>
                              iframe: {{ item.iframe | truncate(50) }}
                            </code>
                            <!-- <p>iframe: {{ item.iframe | truncate(50) }}</p> -->
                          </div>
                          <div class="cl_item"></div>
                          <v-btn class="cl_close" icon @click="delSocial(item)">
                            <span class="material-icons">close</span>
                          </v-btn>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="ctn_btn_shop">
              <v-btn large text @click.stop="show = false">Cerrar</v-btn>
              <v-btn
                :disabled="!valid"
                depressed
                large
                color="primary"
                @click="validate"
                >GUARDAR</v-btn
              >
            </div>

            <!-- <v-btn color="blue darken-1" text @click.stop="show = false"
            >Save</v-btn>-->
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from 'axios'
import lodash from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from 'tiptap-vuetify'
//import AlertMsj from '@/components/dashboard/AlertMsj.vue';

export default {
  props: ['visible'],
  name: 'NewProduct',
  components: {
    TiptapVuetify,
  },
  data() {
    return {
      tab: null,
      name_product: null,
      // description: null,
      userID: null,
      size: null,
      brand: null,
      color: '',
      discount: null,
      itemsDiscount: [],
      talla: '',
      priceInit: 1,
      price: 1,
      cant: 1,
      iframe: null,
      embeSocial: [],
      redSocial: null,
      itemSocial: [
        { id: 1, name: 'Facebook' },
        { id: 2, name: 'Instagram' },
        { id: 3, name: 'Twitter' },
      ],
      imgProduct: null,
      state: false,
      shop: null,
      category: null,
      itemsCategory: null,
      itemsShops: null,
      preview: null,
      stock: [],
      msn: {
        flat: true,
        msj: 'Ok!',
      },
      itemsActive: [
        { id: false, name: 'Inactivo' },
        { id: true, name: 'Activo' },
      ],
      priceRules: [
        (v) => !!v || v > 0 || 'El precio es requerido y debe ser mayor que 1',
      ],
      inputRules: [(v) => !!v || 'El campo es requerido'],
      nameRules: [(v) => !!v || 'El campo es requerido'],
      emailRules: [
        (v) =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          'El formato no es valido',
      ],
      valid: true,
      msj: null,
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      description: `
      <h1>Yay Headlines!</h1>
      <p>All these <strong>cool tags</strong> are working now.</p>
    `,
    }
  },
  mounted() {
    this.userID = this.userId
    this.itemsShops = this.getShops
    this.itemsCategory = this.getCategoryList
    this.numberArray()
  },
  methods: {
    ...mapActions(['listProducts', 'newProduct', 'alertGeneral']),
    numberArray() {
      //let info = [];
      for (let i = 0; i < 99; i++) {
        this.itemsDiscount.push(`${i}%`)
      }
    },
    addCodeSocial() {
      let obj = {
        iframe: this.iframe,
        redSocial: this.redSocial,
      }
      if (this.iframe != null && this.redSocial != null) {
        this.embeSocial.push(obj)
        this.iframe = null
        this.redSocial = null
      } else {
        //console.log('error')
      }
    },
    delSocial(item) {
      let i = this.embeSocial.indexOf(item)
      this.embeSocial.splice(i, 1)
    },
    addStock() {
      let obj = {
        talla: this.talla.toUpperCase(),
        color: this.color,
        price: this.price,
        cant: this.cant,
      }
      if (
        this.price != 0 &&
        this.cant != 0 &&
        this.price != '' &&
        this.cant != ''
      ) {
        this.stock.push(obj)
        this.talla = null
        this.color = null
        this.price = 1
        this.cant = 1
      } else {
        //console.log('error')
      }
    },

    delStock(item) {
      let i = this.stock.indexOf(item)
      this.stock.splice(i, 1)
    },
    validate() {
      if (this.$refs.form.validate()) {
        //this.snackbar = true;
        this.registerForm()
        //router.push({ path: "/editshop" });
      }
    },
    onFileChange(e) {
      if (this.imgProduct != null) {
        const file = e
        //console.log('obj', e)
        //console.log("obj", file);
        this.preview = URL.createObjectURL(file)
      } else {
        this.preview = null
      }
    },

    registerForm() {
      try {
        // generate urlname
        // ref form
        //const params = new URLSearchParams();
        const formData = new FormData()

        formData.append('name', this.name_product)
        formData.append('user', this.userID)
        formData.append('imgShop', this.imgProduct)
        formData.append('state', this.state)
        formData.append('size', this.size)
        formData.append('priceInit', this.priceInit)
        if (this.discount != 'undefined') {
          formData.append('discount', this.discount)
        } else {
        }

        formData.append('category', this.category)
        formData.append('stock', JSON.stringify(this.stock))
        formData.append('embeSocial', JSON.stringify(this.embeSocial))
        //console.log(this.imgShop);
        formData.append('shop', this.shop)
        formData.append('brand', this.brand)
        formData.append('description', this.description)
        // call store api
        //console.log('data send', formData)
        this.newProduct(formData)
        // reset form
        this.tab = null
        this.$refs.form.reset()
        // update table shop
        // this.listProducts();
        this.alertGeneral({
          flat: true,
          msj: 'Nuevo producto creado.',
        })
        // close modal
        this.show = false
      } catch (error) {
        this.alertGeneral({
          flat: true,
          msj: '¡Huy! Ocurrió un error, inténtelo más tarde.',
        })
        this.errmensaje = 'Ops! ocurrio un error con el servidor'
      }
    },
  },

  computed: {
    ...mapGetters(['userId', 'getShops', 'getCategoryList']),
    getCategoryOnly() {
      if (this.shop != null) {
        const result = _.filter(this.itemsCategory, (item) => {
          //console.log('todos --', item)
          //console.log(item.shop._id, ' es igual a ', this.shop)
          if (item.shop._id === this.shop) {
            //console.log('iterno, filtro', item)
            return item
          }
        })
        return result
      } else {
        return []
      }
    },
    isActive() {
      return this.valid
    },

    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$refs.form.reset()
          this.stock = []
          this.embeSocial = []
          this.price = 1
          this.cant = 1
          this.$emit('close')
        }
      },
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/base.scss';
span.headl {
  font-family: 'Roboto Condensed', sans-serif !important;
  font-size: 1.5rem !important;
}
.subhead {
  font-family: 'Roboto Condensed', sans-serif !important;
  font-size: 1rem !important;
}
.tab_tall {
  min-height: 400px;
}
.divbox_add {
  padding: 10px 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
  .v-text-field input {
    height: 50px;
  }
}
.color_span {
  position: relative;
  top: 4px;
  padding-left: 2px;
  border-radius: 50%;
  height: 18px;
  width: 18px;
  display: inline-block;
}
.list-data {
  height: 280px;
  overflow: auto;
}
.cl_stock {
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #ddd;
  //flex: 1 auto;
  .cl_social {
    margin-bottom: 15px;
    display: block;
    p {
      margin-bottom: 5px;
    }
  }
  .cl_item {
    display: flex;
    align-items: center;
    flex-grow: 1;
    //align-items: ;
  }
  .cl_close {
    color: $bar-inactive-dash !important;
    span {
      font-size: 1rem;
    }
  }
}

.cent-add {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.add_array {
  //display: flex;
  //flex-direction: row;
  button.v-btn.add-custom {
    position: relative;
    //top: 15px;
    // padding: 0;
    // height: 32px;
    // border-radius: 50%;
    // min-width: 32px;
  }
}
.wysiwyg {
  padding: 0;
  .container {
    padding: 0;
  }
}
.preview_img {
  width: 100%;
  height: 128px;
  padding: 5px;
  margin-bottom: 15px;
  img {
    max-width: 100%;
    width: 100%;
    height: 128px;
    object-fit: contain;
  }
}
.ctn_btn_shop {
  button.v-btn {
    min-width: 120px !important;
  }
}
</style>
